import React from 'react';
import './PlaystoreDetails.css';

const appUrl = 'https://play.google.com/store/apps/details?id=com.nosc.gpscamera';

function PlaystoreDetails() {

  const handleGetStarted = () => {
    window.open("https://play.google.com/store/apps/details?id=com.nosc.gpscamera")
  };

  const handleDownload = () => {
    window.open("https://play.google.com/store/apps/details?id=com.nosc.gpscamera")
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'GeoCapture - Location Photo App',
        text: 'Check out this cool app that stamps location on photos!',
        url: appUrl
      });
    } else {
      alert('App link copied to clipboard!');
      navigator.clipboard.writeText(appUrl);
    }
  };

  return (
    <div className="playstore-card glass-card">
          <div className="playstore-header">
            <div className="playstore-icon-container">
              <div className="playstore-icon">
                {/* <svg width="48" height="48" viewBox="0 0 40 40" fill="none">
                  <path d="M20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 20 20 8Z" fill="url(#gradient)"/>
                  <path d="M26 15C26 16.6569 24.6569 18 23 18C21.3431 18 20 16.6569 20 15C20 13.3431 21.3431 12 23 12C24.6569 12 26 13.3431 26 15Z" fill="white"/>
                  <defs>
                    <linearGradient id="gradient" x1="8" y1="8" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#667eea"/>
                      <stop offset="1" stopColor="#764ba2"/>
                    </linearGradient>
                  </defs>
                </svg> */}
              </div>
            </div>
            
            <div className="playstore-info">
              <h2 className="playstore-title">GPSC Camera: Geolocation</h2>
              <div className="playstore-developer">
                <span className="developer-name">NOSC</span>
                <div className="verified-badge">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Verified</span>
                </div>
              </div>
              
              {/* <div className="playstore-rating">
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill={i < 4 ? "#FFC107" : "#E0E0E0"}>
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="none"/>
                    </svg>
                  ))}
                  <span className="rating-value">4.8</span>
                </div>
                <span className="downloads">1M+ downloads</span>
              </div> */}
              
              <div className="playstore-tags">
                <span className="tag">Camera App</span>
                <span className="tag">No Video Ads</span>
                <span className="tag">Photo & Video</span>
              </div>
            </div>
          </div>

          <div className="playstore-description">
            <p>GeoCapture is the ultimate app for photographers and travelers. Automatically stamp location data on your photos, organize them by place, and never forget where your memories were made.</p>
            
            <div className="app-highlights">
                <div className="highlight">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13L9 17L19 7" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Free: No Video ads</span>
              </div>
              <div className="highlight">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13L9 17L19 7" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Install GPS camera: geotag photos & add GPS location application in your smartphone</span>
              </div>
              <div className="highlight">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13L9 17L19 7" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Open camera & capture an image and the will automatic stamp your current location with latitude, longitude and altitude.</span>
              </div>
              <div className="highlight">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13L9 17L19 7" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Share with anyone on WhatsApp, Facebook, Gmail, X, Instagram and other.</span>
              </div>
            </div>
          </div>

          {/* <div className="playstore-actions">
            <button className="download-btn" onClick={handleDownload}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 10L12 15L17 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 15V3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Install App</span>
            </button>
            
            <button className="share-btn" onClick={handleShare}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.59 13.51L15.42 17.49" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.41 6.51L8.59 10.49" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Share</span>
            </button>
          </div> */}

          <div className="playstore-footer">
            <div className="size-info">
              <span className="label">Size:</span>
              <span className="value">32 MB</span>
            </div>
            <div className="version-info">
              <span className="label">Version:</span>
              <span className="value">1.1.1</span>
            </div>
            <div className="age-info">
              <span className="label">Rated:</span>
              <span className="value">12+</span>
            </div>
          </div>
        </div>
  );
}

export default PlaystoreDetails;